#import "../fragments/email-automation-status.graphql"

query GetModifiedEmailAutomationsStatuses($after: String, $last: Int) {
    emailAutomationStatusesModified(after: $after, last: $last) {
        pageInfo {
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...EmailAutomationStatus
            }
        }
    }
}
